import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { NavLink, Switch, Route } from 'react-router-dom';
import bio from "../../store/DataBase";

/*const ProjectItem = ({ url, image, title, code }) => {
    return (
        <div className="project-item">
            <a target='_blank' href={url} className="project-thumbnail nivobox" data-lightbox-gallery="portfolio" style={{ backgroundImage: "url(" + { image } + ")" }}>
                <div className="project-description-wrapper">
                    <div className="project-description">
                        <h2 className="project-title">{title}</h2>
                        <span className="see-more code-page"><a target='_blank' href={code}><i className='fa fa-code'></i></a></span>
                    </div>
                </div>
            </a>
            {//<span className="see-more"><i className='fa fa-code'></i></span>}
        </div>
    )
}*/
/*
const ProjectThumb = ({ url, image, title, code }) => {
    return (
        <Col lg={4} md={4} sm={6} xs={6}>
            <Thumbnail href={url} alt="171x180" src={image} target='_blank' />
            <div className="project-description-wrapper">
                <div className="project-description">
                    <h2 className="project-title">{title}</h2>
                    <span className="see-more code-page"><a target='_blank' href={code}><i className='fa fa-code'></i></a></span>
                </div>
            </div>
        </Col>
    )
}*/

const Thumb = ({ image, url, code }) => {
    return (
        <Col lg={4} md={4} sm={4} className='filtr-item' data-category="1" >
            <div className="project">
                <img src={image} alt="" />
                <div className="ovrly">
                </div>
                <div className="buttons">
                    <a href={url} className="fa fa-search" target='_blank' rel='noopener noreferrer'></a>
                    <a href={code} className="fa fa-code show-popup" target='_blank' rel='noopener noreferrer'></a>
                </div>
            </div>
        </Col>
    )
}
/*
const Filters = ({ isSpanish }) => {
    return (
        <Row className='filters'>
            <ul className='cvfilters'>
                <li className='gridactive'>{isSpanish === true ? 'Todos' : 'All'}</li>
                <li href='#JQueryProjects'>Jquery</li>
                <li>React</li>
                <li>{isSpanish === true ? 'Colaborativos' : 'Collaboratives'}</li>
            </ul>
        </Row>
    )
}*/

const AllProjects = ({ isSpanish }) => {
    const AllPj = bio.map((item) => {
        return (
            item.all.map((e, index) => {
                return (
                    <Thumb
                        key={index}
                        image={e.image}
                        url={e.ghPages}
                        code={e.code}
                    />
                )
            })
        )
    })
    return (
        <div className="section-portfolio">
            <Row className='filters'>
                <ul className='cvfilters'>
                    <li className='gridactive'><NavLink to='/portfolio'>{isSpanish === true ? 'Todos' : 'All'}</NavLink></li>
                    <li><NavLink to='/portfolio/jquery'>Jquery</NavLink></li>
                    <li><NavLink to='/portfolio/react'>React</NavLink></li>
                    <li><NavLink to='/portfolio/collaboratives'>{isSpanish === true ? 'Colaborativos' : 'Collaboratives'}</NavLink></li>
                </ul>
            </Row>
            <Row className='' id='projects'>
                {AllPj}
            </Row>
        </div>
    )
}

const JQueryProjects = ({ isSpanish }) => {
    const JQP = bio.map((item) => {
        return (
            item.jquery.map((e, index) => {
                return (
                    <Thumb
                        key={index}
                        image={e.image}
                        url={e.ghPages}
                        code={e.code}
                    />
                )
            })
        )
    })
    return (
        <div className="section-portfolio">
            <Row className='filters'>
                <ul className='cvfilters'>
                    <li><NavLink to='/portfolio'>{isSpanish === true ? 'Todos' : 'All'}</NavLink></li>
                    <li className='gridactive'><NavLink to='/portfolio/jquery'>Jquery</NavLink></li>
                    <li><NavLink to='/portfolio/react'>React</NavLink></li>
                    <li><NavLink to='/portfolio/collaboratives'>{isSpanish === true ? 'Colaborativos' : 'Collaboratives'}</NavLink></li>
                </ul>
            </Row>
            <Row className='' id='projects'>
                {JQP}
            </Row>
        </div>
    )
}

const ReactProjects = ({ isSpanish }) => {
    const ReactRedux = bio.map((item) => {
        return (
            item.reactRedux.map((e, index) => {
                return (
                    <Thumb
                        key={index}
                        image={e.image}
                        url={e.ghPages}
                        code={e.code}
                    />
                )
            })
        )
    })
    return (
        <div className="section-portfolio" >
            <Row className='filters'>
                <ul className='cvfilters'>
                    <li><NavLink to='/portfolio'>{isSpanish === true ? 'Todos' : 'All'}</NavLink></li>
                    <li><NavLink to='/portfolio/jquery'>Jquery</NavLink></li>
                    <li className='gridactive'><NavLink to='/portfolio/react'>React</NavLink></li>
                    <li><NavLink to='/portfolio/collaboratives'>{isSpanish === true ? 'Colaborativos' : 'Collaboratives'}</NavLink></li>
                </ul>
            </Row>
            <Row className='' id='projects'>
                {ReactRedux}
            </Row>
        </div >
    )
}

const CollaborativesProjects = ({ isSpanish }) => {
    const Collab = bio.map((item) => {
        return (
            item.colaborativos.map((e, index) => {
                return (
                    <Thumb
                        key={index}
                        image={e.image}
                        url={e.ghPages}
                        code={e.code}
                    />
                )
            })
        )
    })
    return (
        <div className="section-portfolio">
            <Row className='filters'>
                <ul className='cvfilters'>
                    <li><NavLink to='/portfolio'>{isSpanish === true ? 'Todos' : 'All'}</NavLink></li>
                    <li><NavLink to='/portfolio/jquery'>Jquery</NavLink></li>
                    <li><NavLink to='/portfolio/react'>React</NavLink></li>
                    <li className='gridactive'><NavLink to='/portfolio/collaboratives'>{isSpanish === true ? 'Colaborativos' : 'Collaboratives'}</NavLink></li>
                </ul>
            </Row>
            <Row className='' id='projects'>
                {Collab}
            </Row>
        </div>
    )
}

const Projects = ({ isSpanish }) => {
    return (
        <Switch>
            <Route path='/portfolio/jquery' render={() => <JQueryProjects isSpanish={isSpanish} />} />
            <Route path='/portfolio/react' render={() => <ReactProjects isSpanish={isSpanish} />} />
            <Route path='/portfolio/collaboratives' render={() => <CollaborativesProjects isSpanish={isSpanish} />} />
            <Route exact path='/portfolio' render={() => <AllProjects isSpanish={isSpanish} />} />
        </Switch>
    )
}

export default Projects;


// WEBPACK FOOTER //
// ./src/components/Portfolio/Projects.js